import { Pauser } from "./Pauser";
export function loadExternalPauseInteraction(engine) {
    engine.addInteractor("externalPause", (container) => new Pauser(container));
}
